import { addMonths, differenceInDays, endOfMonth, startOfMonth, getWeek, getWeekOfMonth, max } from "date-fns";
import React, { useEffect, useRef, useState } from "react";
import { Table } from "react-bootstrap";
import { IoMdClose } from "react-icons/io";
import { IoArrowUpSharp, IoArrowDown } from "react-icons/io5";
import { MdOutlineKeyboardArrowRight } from "react-icons/md";
import { Modal, Button, Dropdown } from 'react-bootstrap';
import DayView from './DayViewCalendar.jsx';
import NavBarTop from '../Reusable_Components/NavBarTop'
import LeftNavBar from '../Reusable_Components/LeftNavBar'
import ScheduleEvent from "../Reusable_Components/ScheduleEvent";
import { getAssetCategories, getEventCategories, getAllUsers, getFacmanfromUsers, commercialHeadGetAllFacilitiesForNav, readanCreatedEvent } from "../../Redux/Actions/Actions";
import { useDispatch } from "react-redux";
import { useSelector } from 'react-redux';
import SearchableDropdown from './SearchableDropdown.jsx';
import TableComponent from "./TableComponent";
import Select from 'react-select';
import Loader from '../Reusable_Components/loader';
import Footer from "../Login/Footer.jsx"
import { useNavigate } from "react-router-dom";
import { base_url } from "../../utilities.jsx";
import axios from "axios";
import { use } from "react";
import { formatDateBasedOnValue, formatDateView } from "./ReusableFunctions.js";
import { current } from "@reduxjs/toolkit";
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
dayjs.extend(customParseFormat);



const Calender = (props) => {
    const contractApiLoader = useSelector(state => state.contractApiLoader);
    const navigate = useNavigate()
    const weekBodyConRef = useRef(null);




    const availableOption = ["Year", "Month", "Week", "Day"]
    const daysOfTheWeek = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
    const monthsOfYear = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

    const timeArray = [{ time: '01:00 AM', value: 1 },
    { time: '02:00 AM', value: 2 },
    { time: '03:00 AM', value: 3 },
    { time: '04:00 AM', value: 4 },
    { time: '05:00 AM', value: 5 },
    { time: '06:00 AM', value: 6 },
    { time: '07:00 AM', value: 7 },
    { time: '08:00 AM', value: 8 },
    { time: '09:00 AM', value: 9 },
    { time: '10:00 AM', value: 10 },
    { time: '11:00 AM', value: 11 },
    { time: '12:00 PM', value: 12 },
    { time: '01:00 PM', value: 13 },
    { time: '02:00 PM', value: 14 },
    { time: '03:00 PM', value: 15 },
    { time: '04:00 PM', value: 16 },
    { time: '05:00 PM', value: 17 },
    { time: '06:00 PM', value: 18 },
    { time: '07:00 PM', value: 19 },
    { time: '08:00 PM', value: 20 },
    { time: '09:00 PM', value: 21 },
    { time: '10:00 PM', value: 22 },
    { time: '11:00 PM', value: 23 },
    { time: '12:00 AM', value: 24 },
    ]

    const formattedTimeArray = timeArray.map(timeObj => {
        const [hours, minutes] = timeObj.time?.split(':');
        const isPM = timeObj.time.includes('PM');
        let hour24 = parseInt(hours);

        if (hours === '12') {
            // Handle 12 AM and 12 PM edge cases
            hour24 = isPM ? 12 : 0;
        } else {
            // Convert regular times
            hour24 = isPM ? hour24 + 12 : hour24;
        }

        // Create a Date object
        const dateObj = new Date(1970, 0, 1, hour24, parseInt(minutes));

        return {
            ...timeObj,
            dateObj,
        };
    });

    useEffect(() => {
        if (weekBodyConRef.current) {
            const now = new Date();
            const currentHour = now.getHours();
            const minutesNow = now.getMinutes();

            // Find the closest time slot index
            let targetIndex = formattedTimeArray.findIndex(slot => {
                const slotHour = new Date(slot.dateObj).getHours();
                return slotHour === currentHour;
            });

            if (targetIndex !== -1) {
                const timeSlotElement = weekBodyConRef.current.children[targetIndex];
                if (timeSlotElement) {
                    const offset = timeSlotElement.offsetTop + (minutesNow / 60) * timeSlotElement.clientHeight;
                    weekBodyConRef.current.scrollTop = offset;
                }
            }
        }
    }, [formattedTimeArray]);


    const dispatch = useDispatch()
    const [hourNow, setHourNow] = useState(new Date().getHours())
    const [minutesNow, setMinutesNow] = useState(new Date().getMinutes())
    const [currentOption, setCurrentOption] = useState("Month")
    const [currentPage, setCurrentPage] = useState(2)
    const [currentDay, setCurrentDate] = useState(new Date())
    const [displayTodayDate, setDisplayTodayDate] = useState("")
    const [currentWeek, setCurrentWeek] = useState(0)
    const [weeksData, setWeeksData] = useState([])
    const [modalShow, setModalShow] = useState(false)
    const [showModal, setShowModal] = useState(false)
    const [showWeeklyPopUp, setShowWeeklyPopUp] = useState(false)
    const [weeklyPopupDate, setWeeklyPopupDate] = useState(0)
    const [weeklyPopupDay, setWeeklyPopupDay] = useState("")
    const [weeklyPopUpData, setWeeklyPopUpData] = useState([])
    const [popupDate, setpopupDate] = useState(0)
    const [popupDay, setPopupDay] = useState("")
    const [popupData, setPopupData] = useState([])
    const [weeklyEvents, setWeeklyEvents] = useState({})

    const [selectedScheduleDay, setScheduleDay] = useState(daysOfTheWeek[1])
    const [tasksData, setTasksData] = useState(props.tasksData)
    const [startX, setStartX] = useState(null);
    const currentTimeRef = useRef(null);

    const [date, setDate] = useState(currentDay.getDate())

    //month calender inputs
    const [currentMonth, setCurrentMonth] = useState(currentDay.getMonth())
    const [currentYear, setCurrentYear] = useState(currentDay.getFullYear())
    const [startDate, setStartDate] = useState(startOfMonth(currentDay))
    const [endDate, setEndDate] = useState(endOfMonth(currentDay))
    const [numDays, setNumDays] = useState(differenceInDays(endDate, startDate) + 1)
    const [prefixDays, setPrefixDays] = useState(startDate.getDay())
    const [suffixDays, setSuffixDays] = useState(6 - endDate.getDay())
    const [day, setDay] = useState(new Date(currentYear, currentMonth, date).getDay())
    const [dayCalendarTasks, setDayCalendarTasks] = useState([])
    const getEventList = useSelector(state => state.getEventList)

    const [eventCategoryList, setEventCategoryList] = useState([]);
    const [selectedEvent, setSelectedEvent] = useState([]);
    const eventCategory = useSelector(state => state.eventCategory);

    const [tasksPopup, setTasksPopup] = useState(false);
    const [selectedTaskList, setSelectedTaskList] = useState([]);
    const [selectedTask, setSelectedTask] = useState('');
    const [selectedEventCategory, setSelectedEventCategory] = useState('');

    const [editEvent, setEditEvent] = useState(false);
    const [selectedEventId, setSelectedEventId] = useState('');
    const [eventDetails, setEventDetails] = useState({});

    const [alertShow, setAlertShow] = useState(false);
    const [alertType, setAlertType] = useState('');
    const [alertMessage, setAlertMessage] = useState('');
    const [alertValue, setAlertValue] = useState('');
    const [alertButtons, setAlertButtons] = useState([]);

    const [currentHour, setCurrentHour] = useState(new Date().getHours());
    const [currentMinutes, setCurrentMinutes] = useState(new Date().getMinutes());

    const [selectedCategoryIds, setSelectedCategoryIds] = useState([]);
    const [selectedTableDate, setSelectedTableDate] = useState(null);
    const [facilityList, setFacilityList] = useState([]);
    const [selectedfacility, setSelectedFacility] = useState(`${localStorage.getItem("selected_city_name")}, ${localStorage.getItem("selected_facility_name")}`);
    const facilitiesListForNav = useSelector(state => state.facilitiesListForNav);
    const [selectedFacilityId, setSelectedFacilityId] = useState(localStorage.getItem("selected_facility_id"));
    const [isFacilitySelected, setIsFacilitySelected] = useState(selectedfacility);


    // for yearly view 
    const yearMonthArray = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11]
    const [selectedYear, setSelectedYear] = useState(new Date().getFullYear())
    const [yearlyCalendartasks, setYearlyCalendarTasks] = useState({})

    const getStartOfMonth = (date) => {
        return new Date(Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), 1));
    };

    useEffect(() => {
        dispatch(getEventCategories());
        dispatch(commercialHeadGetAllFacilitiesForNav())
    }, [dispatch]);

    useEffect(() => {
        const interval = setInterval(() => {
            const now = new Date();
            setCurrentHour(now.getHours());
            setCurrentMinutes(now.getMinutes());
        }, 60000);
        return () => clearInterval(interval);
    }, []);

    useEffect(() => {
        if (eventCategory) {
            let categoryList = ["All"];

            eventCategory?.map((category) =>
                categoryList.push(category.category_name));

            setEventCategoryList(categoryList);
            // setSelectedEvent(categoryList);
        }
    }, [eventCategory]);

    useEffect(() => {
        if (facilitiesListForNav) {
            const options = facilitiesListForNav?.map((facility) => `${facility.city}, ${facility.name}`);
            setFacilityList(options);
        }
    }, [facilitiesListForNav]);


    useEffect(() => {
        if (getEventList) {
            const data = getEventList[0] ? getEventList[0] : [];
            const tasks_keys = Object.keys(data);
            const taskData = {};

            tasks_keys?.forEach((key) => {
                const taskList = data[key];
                taskList?.forEach((task) => {

                    const { task_start_time } = task;
                    const task_date_time_array = task_start_time?.split(" ");
                    const task_time = task_date_time_array[1]
                    const task_date = task_date_time_array[0]
                    const finalTask = {
                        ...task,
                        category_name: key,
                        start_time: task_time,
                    };
                    if (task_date && taskData[task_date]) {
                        taskData[task_date].push(finalTask);
                    } else {
                        taskData[task_date] = [finalTask];
                    }
                })

            })



            // data?.forEach((each) => {
            //     const { begin_date, end_date } = each?.recurrence || {};

            //     // Convert dates to Date objects
            //     const startDate = new Date(begin_date);
            //     const endDate = new Date(end_date);

            //     // Check if dates are valid
            //     if (!isNaN(startDate) && !isNaN(endDate)) {
            //         // Generate all dates between begin_date and end_date
            //         for (
            //             let date = new Date(startDate);
            //             date <= endDate;
            //             date.setDate(date.getDate() + 1)
            //         ) {
            //             // Format the date as 'YYYY-MM-DD'
            //             const formattedDate = date.toISOString()?.split('T')[0];

            //             // Add the event to taskData for the current date
            //             taskData[formattedDate] = taskData[formattedDate]
            //                 ? [...taskData[formattedDate], each]
            //                 : [each];
            //         }
            //     }
            // });

            setTasksData(taskData);
        }
    }, [getEventList]);


    useEffect(() => {

        const facilityId = localStorage.getItem("selected_facility_id")
        const currentDay = new Date(); // Ensure currentDay is set correctly
        const startDate = getStartOfMonth(currentDay).toISOString()?.split('T')[0];
        const endDate = endOfMonth(currentDay).toISOString()?.split('T')[0] + " 23:59:59";

        dispatch(readanCreatedEvent(facilityId, selectedCategoryIds, startDate, endDate))

        const month = new Date()
        const presentMonth = month.getMonth()
        const timer = setInterval(() => {
            setHourNow(new Date().getHours())
            setMinutesNow(new Date().getMinutes())
        }, 60000);
        displayToday()
        setDayCalendarTasks(tasksData[currentYear + "-" + (currentMonth + 1) + "-" + date])
        createWeekDataFunc()
        setDate(currentDay.getDate())
        setDay(new Date(month.getFullYear(), presentMonth, month.getDate()).getDay())
        setDayCalendarTasks(tasksData[month.getFullYear() + "-" + (presentMonth + 1) + "-" + month.getDate()])
        return () => clearInterval(timer);
        setSelectedFacility('');

    }, [])

    useEffect(() => {
        if (currentOption !== "Day") {
            displayTodayMonth()
        }
        const currentTimeString = new Date().getHours();
        const targetDiv = document.getElementById(currentTimeString);
        if (targetDiv) {
            targetDiv.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    }, [currentOption])

    useEffect(() => {
        if (currentPage === 2) {
            setCurrentDate(new Date())
            createWeekDataFunc()
        }
    }, [currentPage])

    useEffect(() => {
        if (tasksData) {
            mapWeeklyEventsToSlots();
        }
    }, [tasksData, currentWeek])

    const handleClose = () => setModalShow(false);
    const handleShow = () => setModalShow(true);
    const changeCurrentPage = (each) => {
        setCurrentOption(each)
        const option = availableOption.indexOf(each)
        if (option === 2) {
            displayTodayMonth()
        }
        setCurrentPage(option + 1)
    }

    const displayToday = () => {
        const today = new Date()
        const todayDate = today.getDate()
        setDisplayTodayDate(todayDate + " " + monthsOfYear[today.getMonth()] + " " + today.getFullYear())
    }

    const mapCallenderMonth = (nextMonth) => {
        setCurrentDate(nextMonth)
        setCurrentMonth(nextMonth.getMonth())
        setCurrentYear(nextMonth.getFullYear())
        const startDate = startOfMonth(nextMonth)
        const endDate = endOfMonth(nextMonth)
        setStartDate(startDate)
        setEndDate(endDate)
        setNumDays(differenceInDays(endDate, startDate) + 1)
        setPrefixDays(startDate.getDay())
        setSuffixDays(6 - endDate.getDay())
    }

    const displayNextMonth = () => {
        const facilityId = localStorage.getItem("selected_facility_id")

        if (currentOption === "Day") {
            let newDate = new Date(currentYear, currentMonth, date).getDay() + 1
            setDay(new Date(currentYear, currentMonth, date).getDay() + 1)
            if (String(endDate)?.split(" ")[2] == date) {
                const nextMonth = addMonths(currentDay, 1)
                mapCallenderMonth(nextMonth)
                setDate(1)
                setDayCalendarTasks(tasksData[nextMonth.getFullYear() + "-" + (currentMonth + 2) + "-" + 1])
            } else {
                setDate(parseInt(date + 1))
                setDayCalendarTasks(tasksData[currentYear + "-" + (currentMonth + 1) + "-" + (date + 1)])
            }
        } else {
            const nextMonth = addMonths(currentDay, 1)
            const startDate = getStartOfMonth(nextMonth).toISOString()?.split('T')[0];
            const endDate = endOfMonth(nextMonth).toISOString()?.split('T')[0] + " 23:59:59";
            dispatch(readanCreatedEvent(facilityId, selectedCategoryIds, startDate, endDate))
            mapCallenderMonth(nextMonth)
            setDay(new Date(currentYear, currentMonth + 1, date).getDay())
        }
    }

    const displayPreviousMonth = () => {
        const facilityId = localStorage.getItem("selected_facility_id")
        if (currentOption === "Day") {
            if (new Date(currentYear, currentMonth, date).getDay() - 1 === -1) {
                setDay(6)
            } else {
                setDay(new Date(currentYear, currentMonth, date).getDay() - 1)
            }
            if (String(startDate)?.split(" ")[2] == date) {
                const nextMonth = addMonths(currentDay, -1)
                setDayCalendarTasks(tasksData[nextMonth.getFullYear() + "-" + (nextMonth.getMonth() + 1) + "-" + (endOfMonth(nextMonth).getDate())])
                setDate(endOfMonth(nextMonth).getDate())
                mapCallenderMonth(nextMonth)
            } else {
                setDate(parseInt(date - 1))
                setDayCalendarTasks(tasksData[currentYear + "-" + (currentMonth + 1) + "-" + (date - 1)])
            }
            // setDate(parseInt(date-1))
        } else {
            const nextMonth = addMonths(currentDay, -1)
            mapCallenderMonth(nextMonth)
            setDay(new Date(currentYear, currentMonth - 1, date).getDay())
            const startDate = getStartOfMonth(nextMonth).toISOString()?.split('T')[0];
            const endDate = endOfMonth(nextMonth).toISOString()?.split('T')[0] + " 23:59:59";
            dispatch(readanCreatedEvent(facilityId, selectedCategoryIds, startDate, endDate))
        }
    }

    const displayTodayMonth = () => {
        const month = new Date()
        const presentMonth = month.getMonth()
        setDayCalendarTasks(tasksData[month.getFullYear() + "-" + presentMonth + 1 + "-" + month.getDate()])
        setDay(new Date(month.getFullYear(), presentMonth, month.getDate()).getDay())
        setDate(currentDay.getDate())
        displayToday()
        mapCallenderMonth(month)
        createWeekDataFunc()
        const currentTimeString = new Date().getHours();
        const targetDiv = document.getElementById(currentTimeString);
        if (targetDiv) {
            targetDiv.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
        const facilityId = localStorage.getItem("selected_facility_id")
        let startDate = getStartOfMonth(month).toISOString()?.split('T')[0];
        let endDate = endOfMonth(month).toISOString()?.split('T')[0] + " 23:59:59";
        if (currentPage === 1) {
            const nextYear = month.getFullYear()
            setCurrentYear(nextYear)
            startDate = new Date(nextYear, 0, 1).toISOString()?.split('T')[0];
            endDate = new Date(nextYear, 11, 31).toLocaleDateString('en-CA') + " 23:59:59";
        }
        dispatch(readanCreatedEvent(facilityId, selectedCategoryIds, startDate, endDate))
    }

    const isToday = (each) => {
        const date = new Date()
        const today = date.getDate()
        const presentMonth = date.getMonth()
        if (each === today && presentMonth === currentMonth) {
            return true
        } else {
            return false
        }
    }


    const createWeekDataFunc = () => {
        const totalDays = []
        const nextMonth = addMonths(currentDay, -1)
        const endDate1 = endOfMonth(nextMonth).getDate()
        const prefix = (Array.from(Array(prefixDays).keys())).reverse()
        const numdays = Array.from(Array(numDays).keys())
        const suffix = Array.from(Array(suffixDays).keys())
        prefix?.map((each) => {
            totalDays.push(endDate1 - each)
        })
        numdays.map(each => {
            totalDays.push(each + 1)
        })
        suffix.map(each => {
            totalDays.push(each + 1)
        })
        const chunkSize = 7;
        const result = [];
        for (let i = 0; i < totalDays.length; i += chunkSize) {
            const chunk = totalDays.slice(i, i + chunkSize);
            result.push(chunk);
        }
        setWeeksData(result)
        setCurrentWeek(getWeekOfMonth(currentDay) - 1)
    }

    const dayCalendarView = (each) => {
        setDayCalendarTasks(tasksData[each])
        setCurrentPage(4)
        setCurrentOption("Day")
        setDate(parseInt(each?.split("-")[2]))
        setDay(new Date(each).getDay())
    }

    const displayPreviousWeek = () => {
        const currentWeekData = currentWeek - 1
        if (currentWeekData <= 0) {
            changeMonthWeek(-1)
        } else {
            setCurrentWeek(currentWeekData)
        }
    }

    const displayNextWeek = () => {
        const currentWeekData = currentWeek + 1
        if (currentWeekData > weeksData.length - 1) {
            changeMonthWeek(1)
        } else {
            setCurrentWeek(currentWeekData)
        }
    }

    //onclick for weekday to day view 
    const handleWeekToDayCalendar = (index) => {

        if (currentWeek === 0) {
            if (weeksData[currentWeek][index] > 20) {
                if (currentMonth === 0) {
                    setDayCalendarTasks(tasksData[(currentYear) + "-" + (12) + "-" + weeksData[currentWeek][index]])
                    setCurrentYear(currentYear - 1)
                    setDay(new Date(currentYear - 1, 11, weeksData[currentWeek][index]).getDay())
                    setDate(weeksData[currentWeek][index])
                    setCurrentMonth(new Date(currentYear, currentMonth - 1, weeksData[currentWeek][index]).getMonth())
                    setCurrentPage(4)
                    setCurrentOption("Day")
                } else {
                    setDayCalendarTasks(tasksData[currentYear + "-" + (currentMonth) + "-" + weeksData[currentWeek][index]])
                    setDay(new Date(currentYear, currentMonth - 1, weeksData[currentWeek][index]).getDay())
                    setDate(weeksData[currentWeek][index])
                    setCurrentMonth(new Date(currentYear, currentMonth - 1, weeksData[currentWeek][index]).getMonth())
                    setCurrentPage(4)
                    setCurrentOption("Day")
                }
            } else if (weeksData[currentWeek][index] < 10) {
                setDayCalendarTasks(tasksData[currentYear + "-" + (currentMonth + 1) + "-" + weeksData[currentWeek][index]])
                setDay(new Date(currentYear, currentMonth, weeksData[currentWeek][index]).getDay())
                setDate(weeksData[currentWeek][index])
                setCurrentMonth(new Date(currentYear, currentMonth, weeksData[currentWeek][index]).getMonth())
                setCurrentPage(4)
                setCurrentOption("Day")
            }
        }
        else if ((currentWeek == weeksData.length - 1)) {
            if (weeksData[currentWeek][index] < 10) {
                if (currentMonth === 11) {
                    setDayCalendarTasks(tasksData[(currentYear + 1) + "-" + (1) + "-" + weeksData[currentWeek][index]])
                    setCurrentYear(currentYear + 1)
                    setDay(new Date(currentYear + 1, 0, weeksData[currentWeek][index]).getDay())
                    setDate(weeksData[currentWeek][index])
                    setCurrentMonth(new Date(currentYear, currentMonth + 1, weeksData[currentWeek][index]).getMonth())
                    setCurrentPage(4)
                    setCurrentOption("Day")
                } else {
                    setDayCalendarTasks(tasksData[currentYear + "-" + (currentMonth + 2) + "-" + weeksData[currentWeek][index]])
                    setCurrentYear(currentYear)
                    setDay(new Date(currentYear, currentMonth + 1, weeksData[currentWeek][index]).getDay())
                    setDate(weeksData[currentWeek][index])
                    setCurrentMonth(new Date(currentYear, currentMonth + 1, weeksData[currentWeek][index]).getMonth())
                    setCurrentPage(4)
                    setCurrentOption("Day")
                }
            } else if (weeksData[currentWeek][index] > 20) {
                setDayCalendarTasks(tasksData[currentYear + "-" + (currentMonth + 1) + "-" + weeksData[currentWeek][index]])
                setDay(new Date(currentYear, currentMonth, weeksData[currentWeek][index]).getDay())
                setDate(weeksData[currentWeek][index])
                setCurrentMonth(new Date(currentYear, currentMonth, weeksData[currentWeek][index]).getMonth())
                setCurrentPage(4)
                setCurrentOption("Day")
            }
        }
        else {
            setDayCalendarTasks(tasksData[currentYear + "-" + (currentMonth + 1) + "-" + weeksData[currentWeek][index]])
            setDay(new Date(currentYear, currentMonth, weeksData[currentWeek][index]).getDay())
            setDate(weeksData[currentWeek][index])
            setCurrentMonth(new Date(currentYear, currentMonth, weeksData[currentWeek][index]).getMonth())
            setCurrentPage(4)
            setCurrentOption("Day")
        }
    }


    const changeMonthWeek = (change) => {
        const totalDays = []
        const nextMonth = addMonths(currentDay, change)
        const previousMonth = addMonths(currentDay, change === 1 ? 0 : change)
        const endDate1 = endOfMonth(previousMonth).getDate()
        setCurrentDate(nextMonth)
        setCurrentMonth(nextMonth.getMonth())
        setCurrentYear(nextMonth.getFullYear())
        const startDate = startOfMonth(nextMonth)
        const endDate = endOfMonth(nextMonth)
        const numDays = (differenceInDays(endDate, startDate) + 1)
        const prefixDays = (startDate.getDay())
        const suffixDays = (6 - endDate.getDay())
        const prefix = (Array.from(Array(prefixDays).keys())).reverse()
        const numdays = Array.from(Array(numDays).keys())
        const suffix = Array.from(Array(suffixDays).keys())
        prefix?.map((each) => {
            totalDays.push(endDate1 - each)
        })
        numdays.map(each => {
            totalDays.push(each + 1)
        })
        suffix.map(each => {
            totalDays.push(each + 1)
        })

        const chunkSize = 7;
        const result = [];
        for (let i = 0; i < totalDays.length; i += chunkSize) {
            const chunk = totalDays.slice(i, i + chunkSize);
            result.push(chunk);
        }
        setWeeksData(result)
        setCurrentWeek(change === 1 ? 1 : result.length - 1)

    }


    //   calloing dispatch function when week is changed
    useEffect(() => {
        getWeekView()
    }, [currentWeek])

    const getWeekView = () => {
        const facilityId = localStorage.getItem("selected_facility_id")
        const data = weeksData[currentWeek];
        if (data) {
            const startDay = data[0];
            const endDay = data[data.length - 1];
            let startDateOfWeek;
            let endDateOfWeek;
            if (currentWeek === 0 && startDay > 20) {
                startDateOfWeek = new Date(currentYear, currentMonth - 1, startDay);
            } else {
                startDateOfWeek = new Date(currentYear, currentMonth, startDay);
            }
            if (currentWeek === weeksData.length - 1 && endDay < 10) {
                endDateOfWeek = new Date(currentYear, currentMonth + 1, endDay);
            } else {
                endDateOfWeek = new Date(currentYear, currentMonth, endDay);
            }

            const startDate = new Date(startDateOfWeek.getTime() - (startDateOfWeek.getTimezoneOffset() * 60000)).toISOString()?.split('T')[0];
            const endDate = new Date(endDateOfWeek.getTime() - (endDateOfWeek.getTimezoneOffset() * 60000)).toISOString()?.split('T')[0];
            if (currentPage === 3) {
                dispatch(readanCreatedEvent(facilityId, selectedCategoryIds, startDate, endDate))
            }
        }
    }

    const setWeeklyPopUp = (dataList, taskDate) => {
        setWeeklyPopUpData(dataList)
        setShowWeeklyPopUp(true)
        // setWeeklyPopupDate(taskDate?.split("-")[2])
        // const day = new Date(taskDate).getDay()
        // setWeeklyPopupDay(daysOfTheWeek[day])
    }


    const handleTouchStart = (e) => {
        setStartX(e.touches[0].clientX);
    };

    const handleTouchEnd = (e) => {
        if (startX && e.changedTouches && e.changedTouches.length > 0) {
            const endX = e.changedTouches[0].clientX;
            const deltaX = endX - startX;
            if (deltaX > 50) {
                handleSwipeRight();
            }
            else if (-deltaX > 50) {
                handleSwipeLeft();
            }

            setStartX(null);
        }
    };

    const handleSwipeRight = () => {

        if (currentPage === 3) {
            displayPreviousWeek()
        }
        if (currentPage === 2) {
            displayPreviousMonth()
        }
    };
    const handleSwipeLeft = () => {

        if (currentPage === 3) {
            displayNextWeek()
        }
        if (currentPage === 2) {
            displayNextMonth()
        }
    };

    const handleUpdateEventDetails = (event) => { // bug 1523 changes 
        let isDateChanged = false;

        const updatedTasks = selectedTaskList.map((task) => {
            if (task.event_id === event.event_id) {
                if (task.event_startDate !== event?.recurrence?.begin_date) {
                    isDateChanged = true;
                }

                return {
                    event_name: event.event_name,
                    event_id: event.event_id,
                    event_category_id: event.event_category_id,
                    event_startTime: event?.recurrence?.event_start_time,
                    asset_name: event?.event_entity_name,
                    event_startDate: event?.recurrence?.begin_date,
                    event_endDate: event?.recurrence?.end_date,
                    entity_type: event?.event_entity_type,
                };
            } else {
                return task;
            }
        });

        setSelectedTaskList(updatedTasks);

        if (isDateChanged) {
            setTasksPopup(false);
        }
    };

    const getEventColor = (eventName) => {
        switch (eventName) {
            case 'Maintenance':
                return '#E9C46A';
            case 'AMC':
                return '#2A9D8F';
            case 'Daily Checklist':
                return '#F4A261';
            case 'PPM':
                return '#264653';
            default:
                return '#E76F51';
        }
    };

    const handleView = (each) => {
        navigate('/FacilityManagerWorkLog', { state: { event: each } });
    }

    const handleDisable = (each) => {

        const today = new Date().toISOString()?.split('T')[0];
        return each.event_startDate <= today;

    }

    const handleEnable = (each) => {
        return false;
    }
    const handleEdit = (each) => {

        const eventId = each.event_id;

        axios.get(base_url + "events?filter_condition=%7B%22event_id%22%3A%22" + eventId + "%22%7D"
        ).then((response) => {
            setEventDetails(response.data.data[0]);
            setModalShow(true);
            setSelectedEventId(eventId);
            setEditEvent(true);
        })

            .catch((error) => {
                setAlertShow(true);
                setAlertType('error');
                setAlertMessage('Error');
                setAlertValue(error?.response?.data.message);
                setAlertButtons([{
                    name: 'Close', action: () => {
                        setAlertShow(false);
                    }
                }]);
            });
    }

    const modifyFacilityFilter = (selectedFacilityId) => {
        localStorage.setItem("selected_facility_id", selectedFacilityId);
        const selectedFacility = facilitiesListForNav?.find((facility) => facility.facility_id === selectedFacilityId);
        localStorage.setItem("selected_facility_name", selectedFacility?.name);
        localStorage.setItem("selected_city_name", selectedFacility?.city);
        setSelectedFacilityId(selectedFacilityId);
        setSelectedFacility(`${selectedFacility?.city}, ${selectedFacility?.name}`);
        setIsFacilitySelected(true);
        setSelectedCategoryIds([]);
        setSelectedEvent([]);
    }

    const mapWeeklyEventsToSlots = () => {

        const updatedWeeklyView = {};
        timeArray.forEach(slot => {

            weeksData[currentWeek]?.forEach(day => {

                const taskDate = `${currentYear}-${String(currentMonth + 1).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
                const tasksForTimeSlot = tasksData[taskDate]?.filter(task => task.event_start_time === slot.time) || [];
                if (tasksForTimeSlot.length > 0) {
                    updatedWeeklyView[`${day}-${slot.time}`] = tasksForTimeSlot;
                }
            });
        });

        setWeeklyEvents(updatedWeeklyView);
    };


    const displayNextYear = () => {
        const nextYear = currentYear + 1
        setCurrentYear(nextYear)
        const startDate = new Date(nextYear, 0, 1).toISOString()?.split('T')[0];
        const endDate = new Date(nextYear, 11, 31).toLocaleDateString('en-CA') + " 23:59:59";
        dispatch(readanCreatedEvent(selectedFacilityId, selectedCategoryIds, startDate, endDate))
    }

    const displayPreviousYear = () => {
        const nextYear = currentYear - 1
        setCurrentYear(nextYear)
        const startDate = new Date(nextYear, 0, 1).toISOString()?.split('T')[0];
        const endDate = new Date(nextYear, 11, 31).toLocaleDateString('en-CA') + " 23:59:59";
        dispatch(readanCreatedEvent(selectedFacilityId, selectedCategoryIds, startDate, endDate))
    }

    const CalendarYearly = (props) => {
        const selectedYear = props.selectedYear;
        const selectedMonth = props.selectedMonth;
        const presentYear = new Date().getFullYear()
        // let tasksForDay = []

        const [year, setYear] = useState(selectedYear);
        const [month, setMonth] = useState(selectedMonth);
        const [tooltip, setTooltip] = useState({ visible: false, x: 0, y: 0, day: null });
        const [tasksForDay, setTasksForDay] = useState([])

        const daysInMonth = new Date(year, month + 1, 0).getDate();
        const firstDay = new Date(year, month, 1).getDay();

        const generateCalendarDays = () => {
            const days = [];
            const clickmonth = month + 1 > 9 ? month + 1 : "0" + (month + 1);

            const clickedDate = `${year}-${clickmonth}-${tooltip.day}`;
            // const presentDate = new Date(clickedDate).toISOString().split("T")[0]

            // Create empty days for the start of the month
            for (let i = 0; i < firstDay; i++) {
                days.push(<div className="day empty" key={`empty-${i}`}></div>);
            }

            // Create days for the current month
            for (let day = 1; day <= daysInMonth; day++) {
                days.push(
                    <div
                        className="day"
                        key={day}
                        onMouseEnter={(e) => showTooltip(e, day)}
                        onMouseLeave={hideTooltip}
                        style={{
                            borderRadius: "50%",
                            width: "30px",
                            height: "30px",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            backgroundColor: isToday(day) && selectedYear === presentYear && selectedMonth === currentMonth
                                ? "blue" : "transparent",
                            color: isToday(day) && selectedYear === presentYear && selectedMonth === currentMonth ? "white" : "black",
                            border: tooltip.visible && tooltip.day === day ? "2px solid blue" : "none",
                        }}
                        onClick={() => {
                            const date = new Date(clickedDate)
                            const month1 = date.getMonth()
                            setCurrentMonth(month1);
                            dayCalendarView(clickedDate)
                        }}
                    >
                        {day}
                    </div>
                );
            }

            return days;
        };

        const showTooltip = (e, day) => {
            const currentMonth = month + 1 > 9 ? month + 1 : "0" + (month + 1);
            const currentDay = day < 10 ? "0" + day : day;
            const clickedDate = `${year}-${currentMonth}-${currentDay}`;
            const tasksForDate = tasksData[clickedDate] || [];
            let tasks = {}
            if (tasksForDate.length > 0) {
                tasksForDate?.forEach((task) => {
                    // split by category name
                    const taskCategory = task.category_name
                    if (tasks[taskCategory]) {
                        tasks[taskCategory] = tasks[taskCategory] + 1
                    } else {
                        tasks[taskCategory] = 1
                    }
                })
            }
            let dayTasks = []
            const taskKeys = Object.keys(tasks)
            taskKeys?.forEach((task) => {
                const taskCount = tasks[task]
                const taskName = task
                if (taskName) {
                    dayTasks.push({ category_name: taskName, count: taskCount })
                }
            })
            setTasksForDay(dayTasks)

            const rect = e.target.getBoundingClientRect();

            setTooltip({
                visible: true,
                x: rect.left + window.scrollX + rect.width / 2 - 50, // Center tooltip under number
                y: rect.bottom + window.scrollY + 5, // Position just below the number
                day: day,
            });
        };

        const hideTooltip = () => {
            // setYearlyCalendarTasks({})
            setTooltip({ ...tooltip, visible: false });
        };

        return (
            <div className="calendar-container"
            // style={{ position: "relative" }}
            >
                <div className="header">
                    <h1>{`${new Date(year, month).toLocaleString('default', { month: 'long' })}`}</h1>
                </div>
                <div className="calendar">
                    <div className="days-of-week">
                        <div>S</div>
                        <div>M</div>
                        <div>T</div>
                        <div>W</div>
                        <div>T</div>
                        <div>F</div>
                        <div>S</div>
                    </div>
                    <div className="days">
                        {generateCalendarDays()}
                    </div>
                    {tooltip.visible && (
                        <div
                            style={{
                                position: 'absolute',
                                left: `${tooltip.x}px`,
                                top: `${tooltip.y}px`,
                                backgroundColor: '#fff',
                                border: '1px solid gray',
                                borderRadius: '5px',
                                padding: '15px',
                                zIndex: 1000,
                                boxShadow: '2px 2px 10px rgba(0, 0, 0, 0.2)',
                            }}
                        >
                            <h6>
                                {tooltip.day < 10 ? "0" + tooltip.day : tooltip.day}-{month + 1 > 9 ? month + 1 : "0" + (month + 1)}-{year}
                            </h6>
                            <div className="d-flex gap-1 justify-content-center">
                                {tasksForDay.length === 0 ? (
                                    <p>No Tasks</p>
                                ) : (
                                    tasksForDay.map((category, index) => (
                                        <div key={index} className="d-flex gap-1">
                                            <div
                                                style={{
                                                    backgroundColor: getEventColor(category?.category_name),
                                                    width: "25px",
                                                    height: "25px",
                                                    borderRadius: "50%",
                                                    textAlign: "center",
                                                    paddingTop: "2px",
                                                    color: "white",
                                                }}
                                            >
                                                <p>{category?.count}</p>
                                            </div>
                                        </div>
                                    ))
                                )}
                            </div>
                        </div>
                    )}

                </div>
            </div>
        );
    };



    return (
        <>
            <>
                <NavBarTop />
                <LeftNavBar />
            </>
            {contractApiLoader && <Loader />}
            <div className="calendar_container_div">
                <div className="calender-heading-container">
                    <div >
                        <h1 className="C-pointer" onClick={() => { displayTodayMonth() }}>{displayTodayDate}</h1>
                        <div className="mobile-view-month-year">
                            {currentWeek === weeksData.length - 1 ?
                                <p onClick={() => { displayTodayMonth() }}>{monthsOfYear[currentMonth].slice(0, 3)}-{(currentMonth === 11 ? monthsOfYear[0] : monthsOfYear[currentMonth + 1]).slice(0, 3)} {currentYear}</p>
                                :
                                currentWeek === 0 ?
                                    <p onClick={() => { displayTodayMonth() }}>{(currentMonth === 0 ? monthsOfYear[11] : monthsOfYear[currentMonth - 1]).slice(0, 3)}-{monthsOfYear[currentMonth].slice(0, 3)} {currentYear}</p>
                                    :
                                    <p onClick={() => { displayTodayMonth() }}>{monthsOfYear[currentMonth]} {currentYear}</p>
                            }
                        </div>
                    </div>
                    <div className="d-flex gap-4">
                        {currentPage === 1 && <div className="calender-heading-card">
                            <div className="d-flex gap-1">
                                <p className="C-pointer" onClick={() => { displayPreviousYear() }}><IoArrowUpSharp /></p>
                                <p className="C-pointer" onClick={() => { displayNextYear() }}><IoArrowDown /></p>
                            </div>
                            <p>{currentYear}</p>

                        </div>}
                        {currentPage === 2 && <div className="calender-heading-card">
                            <div className="d-flex gap-1">
                                <p className="C-pointer" onClick={() => { displayPreviousMonth() }}><IoArrowUpSharp /></p>
                                <p className="C-pointer" onClick={() => { displayNextMonth() }}><IoArrowDown /></p>
                            </div>
                            <p> {monthsOfYear[currentMonth]} {currentYear}</p>

                        </div>}
                        {currentPage === 3 && <div className="calender-heading-card">
                            <div className="d-flex gap-1">
                                <p className="C-pointer" onClick={() => { displayPreviousWeek() }}><IoArrowUpSharp /></p>
                                <p className="C-pointer" onClick={() => { displayNextWeek() }}><IoArrowDown /></p>
                            </div>

                            {currentWeek === weeksData.length - 1 ?
                                <p>{monthsOfYear[currentMonth].slice(0, 3)}-{(currentMonth === 11 ? monthsOfYear[0] : monthsOfYear[currentMonth + 1]).slice(0, 3)} {currentYear}</p>
                                :
                                currentWeek === 0 ?
                                    <p>{(currentMonth === 0 ? monthsOfYear[11] : monthsOfYear[currentMonth - 1]).slice(0, 3)}-{monthsOfYear[currentMonth].slice(0, 3)} {currentYear}</p>
                                    :
                                    <p>{monthsOfYear[currentMonth]} {currentYear}</p>
                            }

                        </div>}
                        {currentPage === 4 && <div className="calender-heading-card">
                            <div className="d-flex gap-1">
                                <p className="C-pointer" onClick={() => { displayPreviousMonth() }}><IoArrowUpSharp /></p>
                                <p className="C-pointer" onClick={() => { displayNextMonth() }}><IoArrowDown /></p>
                            </div>
                            <p>{date} {monthsOfYear[currentMonth]} {currentYear}</p>

                        </div>}
                        <div className="current-view-options">
                            {availableOption.map((each, index) => {
                                return (
                                    <p key={index} onClick={() => { changeCurrentPage(each) }}
                                        className={`${each === currentOption ? 'calender-selectedOption  C-pointer' : 'C-pointer'}`}>{each}</p>//select month/year/filters
                                )
                            })}
                        </div>
                        <div >
                            <select className="current-view-options-sm" value={currentOption}
                                onChange={(e) => changeCurrentPage(e.target.value)}>
                                {availableOption.map((each, index) => (
                                    <option key={index} value={each}
                                        className={`${each === currentOption ? 'calender-selectedOption C-pointer' : 'C-pointer'}`}>
                                        {each}
                                    </option>
                                ))}
                            </select>
                        </div>

                    </div>
                    <button
                        onClick={() => {
                            handleShow()
                            dispatch(getAssetCategories())
                            dispatch(getEventCategories())
                            dispatch(getAllUsers("Technician"))
                            dispatch(getFacmanfromUsers("Facility Manager"))
                            dispatch(commercialHeadGetAllFacilitiesForNav())
                        }}
                        className="schedule-date">
                        <p className="C-pointer">+</p>
                        <p className="heading">Schedule Event</p>
                    </button>
                    <div onClick={() => { setModalShow(true) }} className="schedule-date-sm">
                        <p className="C-pointer">+</p>
                    </div>
                </div>
                {/* dropdown and legend */}
                <div className='calendar-filters ' style={{ marginTop: '-30px' }}>
                    <div className='d-flex align-items-right'>
                        <SearchableDropdown
                            className="searchable-dropdown2"

                            options={facilityList ? facilityList : []} //facilityList is the array of facilities
                            selectedOption={selectedfacility}
                            noOptionsAvailable="Facility unavailable"
                            onChange={(e) => {
                                setSelectedFacility(e.value)
                                const selectedFacility = facilitiesListForNav?.find((facility) => `${facility.city}, ${facility.name}` === e.value);
                                localStorage.setItem("selected_facility_id", selectedFacility?.facility_id);
                                localStorage.setItem("selected_facility_name", selectedFacility?.name);
                                localStorage.setItem("selected_city_name", selectedFacility?.city);

                                setSelectedFacilityId(selectedFacility?.facility_id);
                                setIsFacilitySelected(true);
                                let startDate
                                let endDate
                                if (currentPage === 1) {
                                    startDate = new Date(currentYear, 0, 1).toISOString()?.split('T')[0];
                                    endDate = new Date(currentYear, 11, 31).toISOString()?.split('T')[0] + " 23:59:59";
                                } else if (currentPage === 2) {
                                    startDate = getStartOfMonth(currentDay).toISOString()?.split('T')[0];
                                    endDate = endOfMonth(currentDay).toISOString()?.split('T')[0] + " 23:59:59";
                                } else if (currentPage === 3) {
                                    const data = weeksData[currentWeek];
                                    if (data) {
                                        const startDay = data[0];
                                        const endDay = data[data.length - 1];
                                        let startDateOfWeek;
                                        let endDateOfWeek;
                                        if (currentWeek === 0 && startDay > 20) {
                                            startDateOfWeek = new Date(currentYear, currentMonth - 1, startDay);
                                        } else {
                                            startDateOfWeek = new Date(currentYear, currentMonth, startDay);
                                        }
                                        if (currentWeek === weeksData.length - 1 && endDay < 10) {
                                            endDateOfWeek = new Date(currentYear, currentMonth + 1, endDay);
                                        } else {
                                            endDateOfWeek = new Date(currentYear, currentMonth, endDay);
                                        }

                                        startDate = new Date(startDateOfWeek.getTime() - (startDateOfWeek.getTimezoneOffset() * 60000)).toISOString()?.split('T')[0];
                                        endDate = new Date(endDateOfWeek.getTime() - (endDateOfWeek.getTimezoneOffset() * 60000)).toISOString()?.split('T')[0];
                                    }

                                } else {
                                    const clickDate = `${currentYear}-${String(currentMonth + 1).padStart(2, '0')}-${String(date).padStart(2, '0')}`;
                                    const clickDate1 = new Date(clickDate);
                                    const endDate1 = new Date(clickDate);
                                    endDate1.setDate(endDate1.getDate() + 1);
                                    const formattedEndDate = endDate1.toISOString()?.split('T')[0];
                                    startDate = clickDate1.toISOString()?.split('T')[0];
                                    endDate = formattedEndDate;
                                }

                                if (selectedCategoryIds.length === 0) {
                                    dispatch(readanCreatedEvent(selectedFacility.facility_id, selectedCategoryIds, startDate, endDate))
                                } else {
                                    dispatch(readanCreatedEvent(selectedFacility.facility_id, selectedCategoryIds, startDate, endDate))
                                }
                            }}

                            placeholder="Select Facility"
                            isDisabled={false}
                        />
                    </div>
                    <div className='d-flex align-items-right gap-3' >

                        <SearchableDropdown
                            className="searchable-dropdown2"
                            options={eventCategoryList ? eventCategoryList : []}
                            selectedOption={selectedEvent}
                            noOptionsAvailable="Category unavailable"
                            onChange={(e) => {
                                setSelectedEvent(e.map((option) => option.value))


                                let startDate
                                let endDate
                                if (currentPage === 1) {
                                    startDate = new Date(currentYear, 0, 1).toISOString()?.split('T')[0];
                                    endDate = new Date(currentYear, 11, 31).toISOString()?.split('T')[0] + " 23:59:59";
                                } else if (currentPage === 2) {
                                    startDate = getStartOfMonth(currentDay).toISOString()?.split('T')[0];
                                    endDate = endOfMonth(currentDay).toISOString()?.split('T')[0] + " 23:59:59";
                                } else if (currentPage === 3) {
                                    const data = weeksData[currentWeek];
                                    if (data) {
                                        const startDay = data[0];
                                        const endDay = data[data.length - 1];
                                        let startDateOfWeek;
                                        let endDateOfWeek;
                                        if (currentWeek === 0 && startDay > 20) {
                                            startDateOfWeek = new Date(currentYear, currentMonth - 1, startDay);
                                        } else {
                                            startDateOfWeek = new Date(currentYear, currentMonth, startDay);
                                        }
                                        if (currentWeek === weeksData.length - 1 && endDay < 10) {
                                            endDateOfWeek = new Date(currentYear, currentMonth + 1, endDay);
                                        } else {
                                            endDateOfWeek = new Date(currentYear, currentMonth, endDay);
                                        }

                                        startDate = new Date(startDateOfWeek.getTime() - (startDateOfWeek.getTimezoneOffset() * 60000)).toISOString()?.split('T')[0];
                                        endDate = new Date(endDateOfWeek.getTime() - (endDateOfWeek.getTimezoneOffset() * 60000)).toISOString()?.split('T')[0];
                                    }

                                } else {
                                    const clickDate = `${currentYear}-${String(currentMonth + 1).padStart(2, '0')}-${String(date).padStart(2, '0')}`;
                                    const clickDate1 = new Date(clickDate);
                                    const endDate1 = new Date(clickDate);
                                    endDate1.setDate(endDate1.getDate() + 1);
                                    const formattedEndDate = endDate1.toISOString()?.split('T')[0];
                                    startDate = clickDate1.toISOString()?.split('T')[0];
                                    endDate = formattedEndDate;
                                }


                                const listOfEvents = e.map((option) => option.value)
                                if ((listOfEvents?.length === 0) || listOfEvents?.includes('All')) {
                                    setSelectedCategoryIds([]);
                                    dispatch(readanCreatedEvent(selectedFacilityId, [], startDate, endDate))
                                } else {

                                    const selectedCategoryIds = eventCategory?.filter((category) => listOfEvents.includes(category.category_name)).map((category) => category.event_category_id);
                                    setSelectedCategoryIds(selectedCategoryIds);
                                    const selectedCategoryIdsString = encodeURIComponent(JSON.stringify(selectedCategoryIds));
                                    dispatch(readanCreatedEvent(selectedFacilityId, selectedCategoryIds, startDate, endDate))
                                }
                            }}
                            // name = "Event"
                            placeholder="Select Event"
                            isDisabled={!isFacilitySelected}
                            isMulti={true}
                        />

                    </div>
                    <div className='d-flex  justify-content-end mt-2'>
                        <div className="legend" >
                            <div className="legend-item">
                                <div className="legend-square category-1"></div>
                                <span>PPM</span>
                            </div>
                            <div className="legend-item">
                                <div className="legend-square category-2"></div>
                                <span>AMC</span>
                            </div>
                            <div className="legend-item">
                                <div className="legend-square category-3"></div>
                                <span>Maintenance</span>
                            </div>
                            <div className="legend-item">
                                <div className="legend-square category-4"></div>
                                <span>Daily CheckList</span>
                            </div>
                            {/* <div className="legend-item">
                                    <div className="legend-square category-5"></div>
                                    <span>Others</span>
                                </div> */}
                        </div>
                    </div>
                </div>
                <div className="dates-container">
                    {currentPage === 1 &&
                        <div className="year-container-view">
                            <div className="year-container" >
                                {yearMonthArray.map((each, index) => {
                                    return (
                                        <div key={index} >
                                            <CalendarYearly selectedYear={currentYear} selectedMonth={each} />
                                        </div>)
                                })}
                            </div>
                        </div>}
                    {currentPage === 2 && <div>
                        <div
                            onTouchStart={handleTouchStart}
                            onTouchEnd={handleTouchEnd}
                            className="month-container">
                            <Table className="month-table">
                                <thead className="month-container-days">
                                    {daysOfTheWeek.map((each, index) => <tr key={index}>
                                        <td>{each}</td>
                                    </tr>)}
                                </thead>
                                <tbody className="month-date-container">
                                    {(Array.from(Array(prefixDays).keys())).reverse().map((each, index) => {
                                        const nextMonth = addMonths(currentDay, -1)
                                        const endDate1 = endOfMonth(nextMonth).getDate()
                                        const presentDate = String(currentYear + "-" + (currentMonth) + "-" + (endDate1 - each))
                                        let taskList
                                        let newTaskList = {}
                                        if (tasksData[presentDate]) {
                                            taskList = Object.values(tasksData[presentDate]);
                                        }
                                        return (
                                            <tr key={`preffix-day-${index}`} className="card preffix-month-card">
                                                <td className="preffix-month-card-details">
                                                    {/* <p>{endDate1-each}</p> */}
                                                    {taskList?.length > 0 &&
                                                        <div>
                                                            <div >
                                                                <div className="mt-1">
                                                                    <div className={`${isToday(each + 1) ? 'today-task-card' : 'task-card'}`}>
                                                                        <p className="tasklist-taskname">{taskList[0].event_name}</p>
                                                                        <MdOutlineKeyboardArrowRight />
                                                                    </div>

                                                                    {taskList?.length > 1 &&
                                                                        <div>
                                                                            <div className={`${isToday(each + 1) ? 'today-task-card mt-1' : 'task-card mt-1'}`}>
                                                                                <p className="tasklist-taskname">{taskList[1].event_name}</p>
                                                                                <MdOutlineKeyboardArrowRight />
                                                                            </div>
                                                                            {
                                                                                taskList?.length > 2 ?
                                                                                    <div className="tasklist-extra">
                                                                                        <p className="round">+{taskList.length - 2}</p>
                                                                                    </div>
                                                                                    :
                                                                                    <p></p>
                                                                            }
                                                                        </div>}
                                                                </div>
                                                            </div>
                                                            <div className="pre-month-view-medium">
                                                                {taskList?.length > 0 &&
                                                                    <div>
                                                                        {taskList?.map((task, index) => {
                                                                            if (index < 7) {
                                                                                return (
                                                                                    <div className="mt-1">
                                                                                        <div key={index} className={`${isToday(each + 1) ? 'today-task-card' : 'task-card'}`}>
                                                                                            <p className="tasklist-taskname">{task.event_name}</p>
                                                                                            <MdOutlineKeyboardArrowRight />
                                                                                        </div>
                                                                                    </div>
                                                                                )
                                                                            }
                                                                        })}
                                                                        {
                                                                            taskList?.length > 7 ?
                                                                                <div className="tasklist-extra-md">
                                                                                    {/* <p onClick={()=>setPerDayModal(each+1)} className="round">+{taskList.length-7}</p> */}
                                                                                </div>
                                                                                :
                                                                                <p></p>
                                                                        }
                                                                    </div>

                                                                }
                                                            </div>

                                                        </div>
                                                    }
                                                </td>
                                            </tr>
                                        )
                                    })}
                                    {/* current month */}
                                    {(Array.from(Array(numDays).keys())).map((each, index) => {
                                        const presentDate = `${currentYear}-${String(currentMonth + 1).padStart(2, '0')}-${String(each + 1).padStart(2, '0')}`;

                                        let taskList
                                        let newTaskList = []

                                        if (tasksData[presentDate]) {
                                            let data = tasksData[presentDate]
                                            data?.map((each) => {
                                                // if(each.event_name === 'All'){
                                                if (newTaskList[each.category_name]) {
                                                    newTaskList[each.category_name].push(each)

                                                } else {
                                                    newTaskList[each.category_name] = []
                                                    newTaskList[each.category_name].push(each)

                                                }

                                            })
                                            if (newTaskList.length !== 0) taskList.push(newTaskList)
                                        }

                                        const taskKeys = Object.keys(newTaskList)

                                        return (
                                            <tr key={index} className='card'>
                                                <td className={`${isToday(each + 1) ? 'month-date-card today-card' : 'month-date-card'}`}>
                                                    <p onClick={() => dayCalendarView(presentDate)} className="C-pointer">{each + 1}</p>
                                                    <div>

                                                        {newTaskList &&
                                                            <div>
                                                                <div className='d-flex gap-2 flex-wrap mt-1'>
                                                                    {taskKeys.map((task, taskIndex) => {
                                                                        return (

                                                                            <div key={taskIndex} className="legend-item" style={{ backgroundColor: getEventColor(task) }}>
                                                                                <div className="task-boxes"
                                                                                    onClick={() => {
                                                                                        const date = formatDateView(presentDate)
                                                                                        setSelectedTableDate(date)
                                                                                        const data = newTaskList[task]?.map(each => {
                                                                                            const startTime = each?.task_start_time?.split(" ")[0]

                                                                                            return {
                                                                                                event_name: each?.task_name,
                                                                                                event_id: each.event_id,
                                                                                                event_category_id: each.event_category_id,
                                                                                                event_startTime: each?.start_time,
                                                                                                asset_name: each?.entity_name,
                                                                                                entity_type: each?.entity_type,
                                                                                                event_startDate: startTime,
                                                                                                event_endDate: startTime,
                                                                                                category_name: each.category_name,
                                                                                            }
                                                                                        })

                                                                                        setTasksPopup(true)
                                                                                        setSelectedTaskList(data)
                                                                                        setSelectedTask(task)

                                                                                    }}
                                                                                >{newTaskList[task]?.length}</div>
                                                                            </div>
                                                                        )

                                                                    })}
                                                                </div>
                                                            </div>
                                                        }
                                                    </div>
                                                    {/* <div className="month-view-medium">
                                                            {taskList?.length > 0 && 
                                                                <div>
                                                                    {taskList?.map((task,index)=>{
                                                                        if(index<7){
                                                                            return (
                                                                                <div className="mt-1">
                                                                                    <div  key={index} className={`${isToday(each+1)?'today-task-card':'task-card'}`}>
                                                                                        <p className="tasklist-taskname">{task.event_name}</p>
                                                                                        <MdOutlineKeyboardArrowRight />
                                                                                    </div>
                                                                                </div>
                                                                            )
                                                                        }
                                                                    })}
                                                                    {
                                                                    taskList?.length>7?
                                                                    <div className="tasklist-extra-md">
                                                                        <p onClick={()=>setPerDayModal(each+1)} className="round">+{taskList.length-7}</p>
                                                                        </div>
                                                                    :
                                                                    <p></p>
                                                                }
                                                                </div>
                                                                
                                                            }
                                                        </div> */}

                                                </td>
                                            </tr>
                                        )
                                    })}
                                    {/* next month calendar code */}
                                    {(Array.from(Array(suffixDays).keys())).map((each, index) => {
                                        const presentDate = String(currentYear + "-" + (currentMonth + 2) + "-" + (each + 1))
                                        let taskList
                                        if (tasksData[presentDate]) {
                                            taskList = Object.values(tasksData[presentDate]);
                                        }
                                        return (
                                            <tr key={`suffic-day-${index}`} className="card preffix-month-card">
                                                <td className="preffix-month-card-details">
                                                    {/* <p>{each+1}</p> */}
                                                    {taskList?.length > 0 &&
                                                        <div className="mt-1">
                                                            <div className={`${isToday(each + 1) ? 'today-task-card' : 'task-card'}`}>
                                                                <p className="tasklist-taskname">{taskList[0].event_name}</p>
                                                                <MdOutlineKeyboardArrowRight />
                                                            </div>

                                                            {taskList?.length > 1 &&
                                                                <div>
                                                                    <div className={`${isToday(each + 1) ? 'today-task-card mt-1' : 'task-card mt-1'}`}>
                                                                        <p className="tasklist-taskname">{taskList[1].event_name}</p>
                                                                        <MdOutlineKeyboardArrowRight />
                                                                    </div>
                                                                    {
                                                                        taskList?.length > 2 ?
                                                                            <div className="tasklist-extra">
                                                                                <p className="round">+{taskList.length - 2}</p>
                                                                            </div>
                                                                            :
                                                                            <p></p>
                                                                    }
                                                                </div>}
                                                        </div>
                                                    }
                                                </td>
                                            </tr>
                                        )
                                    })}
                                </tbody>
                            </Table>
                        </div>
                        {/* <div>
                                <PerDayEventDetails />
                            </div> */}
                        {/* {hourNow===each.value && currentWeek === (getWeekOfMonth(new Date())-1) &&
                                                                            <div className="hour-line" style={{top: `calc((${100*minutesNow}% / ${60}))`}}>
                                                                            </div>} */}
                    </div>}
                    {currentPage === 3 && <div>
                        <div
                            onTouchStart={handleTouchStart}
                            onTouchEnd={handleTouchEnd}
                            className="week-view-container">
                            <div className="week-view">
                                <div>
                                    <div className="week-table">
                                        <div className="week-days-con">
                                            <div>
                                                <div className="week-day-timeHeader">

                                                </div>
                                            </div>
                                            {daysOfTheWeek?.map((each, index) => {
                                                const today = new Date()
                                                const isToday = today.getDate() === weeksData[currentWeek][index] && currentMonth === today.getMonth()
                                                    && currentYear === today.getFullYear()
                                                return (
                                                    <div key={index} className="week-con"
                                                        onClick={() => {
                                                            handleWeekToDayCalendar(index)
                                                        }}
                                                    >
                                                        <div className="week-con-each-day">
                                                            <p>{each.slice(0, 3)}</p>
                                                            <p className={`${isToday ? 'highlight-today' : 'highlight'}`}
                                                            >{weeksData[currentWeek][index]}</p>
                                                        </div>
                                                    </div>
                                                )
                                            })}
                                        </div>
                                        <div className="week-body-con" >
                                            {formattedTimeArray.map((slot, index) => {
                                                return (
                                                    <div key={index} className="week-body">
                                                        <div className="week-body-time">
                                                            <p>{slot.time}</p>
                                                        </div>
                                                        {/* Events Per Day in Week */}
                                                        <div className="week-body-each-day">
                                                            {weeksData[currentWeek]?.map((day, dayIndex) => {
                                                                const taskDate = `${currentYear}-${String(currentMonth + 1).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
                                                                // const todayForTime = taskDate === new Date().getDate()
                                                                const todayForTime = taskDate === `${new Date().getFullYear()}-${String(new Date().getMonth() + 1).padStart(2, '0')}-${String(new Date().getDate()).padStart(2, '0')}`;

                                                                const tasksForSlot = tasksData[taskDate]?.filter(task => {
                                                                    const taskStartTime = new Date(`1970-01-01T${task?.start_time}`);
                                                                    const slotStartTime = new Date(slot.dateObj);
                                                                    const slotEndTime = new Date(slotStartTime.getTime() + 60 * 60 * 1000); // Add one hour

                                                                    return taskStartTime >= slotStartTime && taskStartTime < slotEndTime;
                                                                }) || [];
                                                                const taskGroup = tasksData[taskDate]?.filter(task => {
                                                                    const taskStartTime = new Date(`1970-01-01T${task?.start_time}`);
                                                                    const slotDate = new Date(slot.dateObj);
                                                                    const oneHourLater = new Date(slotDate.getTime() + 60 * 60 * 1000);

                                                                    return taskStartTime >= slotDate && taskStartTime < oneHourLater;
                                                                });

                                                                const tasksTypes1 = taskGroup?.reduce((acc, each) => {
                                                                    if (acc[each.category_name]) {
                                                                        acc[each.category_name].push(each);
                                                                    } else {
                                                                        acc[each.category_name] = [each];
                                                                    }
                                                                    return acc;
                                                                }
                                                                    , {});
                                                                let taskTypeKeys
                                                                if (tasksTypes1) {
                                                                    taskTypeKeys = Object.keys(tasksTypes1);
                                                                }
                                                                return (
                                                                    <div key={`${index}-${dayIndex}`} id={index + 2} ref={index === 0 ? currentTimeRef : null} className="week-body-each">
                                                                        {tasksForSlot.length > 0 && taskTypeKeys && (
                                                                            <div className="d-flex gap-2 flex-wrap mt-1">
                                                                                {taskTypeKeys.map((taskType, taskTypeIndex) => {
                                                                                    return (
                                                                                        <div key={taskTypeIndex} className="legend-item" style={{ backgroundColor: getEventColor(taskType) }}>
                                                                                            <div
                                                                                                className="task-boxes"
                                                                                                onClick={() => {
                                                                                                    const data = tasksTypes1[taskType].map(each => {
                                                                                                        const startTime = each?.task_start_time?.split(" ")[0]
                                                                                                        return ({
                                                                                                            event_name: each?.task_name,
                                                                                                            event_id: each.event_id,
                                                                                                            event_category_id: each.event_category_id,
                                                                                                            event_startTime: each?.start_time,
                                                                                                            asset_name: each?.entity_name,
                                                                                                            entity_type: each?.entity_type,
                                                                                                            event_startDate: startTime,
                                                                                                            event_endDate: startTime,
                                                                                                            category_name: each.category_name,
                                                                                                        })
                                                                                                    });

                                                                                                    setTasksPopup(true);
                                                                                                    setSelectedTableDate(taskDate);
                                                                                                    setSelectedTaskList(data);
                                                                                                    setSelectedTask(taskType);
                                                                                                }}
                                                                                            >
                                                                                                {tasksTypes1[taskType].length}
                                                                                            </div>
                                                                                        </div>
                                                                                    );
                                                                                })}
                                                                            </div>
                                                                        )}
                                                                        {/* hour line */}
                                                                        {hourNow === slot.value && currentWeek === (getWeekOfMonth(new Date()) - 1) &&
                                                                            <div>
                                                                                {todayForTime ?
                                                                                    <div className="hour-line" style={{ top: `calc((${100 * minutesNow}% / ${60}))` }}>
                                                                                    </div>
                                                                                    :
                                                                                    <div className="hour-line" style={{ top: `calc((${100 * minutesNow}% / ${60}))`, border: "1px dashed rgb(12, 179, 235)", borderSpacing: "5px" }}>
                                                                                    </div>
                                                                                }


                                                                            </div>}
                                                                    </div>
                                                                );
                                                            })}
                                                        </div>
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    }

                    {/* DAYVIEW */}
                    {currentPage === 4 && <div style={{ width: "100vw" }}>
                        <DayView clickDate={`${date}-${monthsOfYear[currentMonth]}-${currentYear}`}
                            allTasks={tasksData}
                            handleEdit={handleEdit}
                            setSelectedTableDate={setSelectedTableDate}
                            selectedDay={selectedTableDate}
                        />
                    </div>}

                    <ScheduleEvent
                        selectedfacility={selectedfacility}
                        show={modalShow}
                        onHide={() => setModalShow(false)}
                        daysOfTheWeek={daysOfTheWeek}
                        modalData={eventDetails}
                        handleUpdateEventDetails={handleUpdateEventDetails}
                        modifyFacilityFilter={modifyFacilityFilter}
                        currentPage={currentPage}
                        selectedTableDate={selectedTableDate}
                        startOfMonth={startOfMonth}
                        endOfMonth={endOfMonth}
                        weeksData={weeksData}
                        currentWeek={currentWeek}
                        currentMonth={currentMonth}
                        currentYear={currentYear}
                        currentDay={currentDay}
                        date={date}
                        selectedCategoryIds={selectedCategoryIds}
                        getStartOfMonth={getStartOfMonth}
                        setEventDetails={setEventDetails}
                    />
                    {/* tasks popup modal */}
                    <Modal keyboard={false} backdrop="static" show={tasksPopup}
                        centered onHide={() => {
                            setTasksPopup(false)
                            setEventDetails({})
                        }
                        }>
                        <div>
                            <Modal.Header closeButton>
                                
                                <Modal.Title>{selectedTask} <span style={{ fontSize: 'medium' }}>on {formatDateBasedOnValue(selectedTableDate)}</span>
                            
                                </Modal.Title>
                            </Modal.Header>
                            <div className="per-day-events-body">
                                <div>
                                    <TableComponent
                                        headers={[
                                            { name: "Event", type: "text", key: "event_name" },
                                            { name: 'Entity Type', type: 'text', key: 'entity_type' },
                                            { name: "Entity Name", type: "text", key: "asset_name" },
                                            { name: "Scheduled At", type: "text", key: "event_startTime" },
                                            {
                                                name: "Action", type: "button", buttons: [
                                                    {
                                                        name: "view",
                                                        icon: "./images/icons/View.png",
                                                        action: handleView,
                                                        disable: handleEnable
                                                    },
                                                    {
                                                        name: "edit",
                                                        icon: "./images/icons/Edit.svg",
                                                        action: handleEdit,
                                                        disable: handleDisable
                                                    },
                                                ]
                                            }
                                        ]}
                                        data={selectedTaskList}
                                    // loading={isLoading}
                                    />
                                </div>
                            </div>
                        </div>
                    </Modal>
                </div>
            </div>
            <Footer />
        </>
    )
}

export default Calender